/**
 * App init: ready document loaded
 * @param callback
 */
export const ready = (callback) => {
    if (document.readyState !== "loading") {
        callback()
    } else {
        document.addEventListener("DOMContentLoaded", callback)
    }
}

/**
 * Editor init: ready window loaded
 * We use window.onload because unregisterBlockStyle doesn't work inside wp.domReady
 * Source: https://github.com/WordPress/gutenberg/issues/25330
 * @param callback
 */
export const editorReady = (callback) => {
    window.onload = () => {
        callback()
    }
}
